import {AddressSuggestion} from "../@types/address";

export const persistAddress = (address: AddressSuggestion): void => {
  localStorage.setItem('selectedAddress', JSON.stringify(address));
};

export const readAddress = (): AddressSuggestion | null => {
  const selectedAddress = localStorage.getItem('selectedAddress');

  return selectedAddress ? JSON.parse(selectedAddress) : null;
};

export const deleteAddress = (): void => localStorage.removeItem('selectedAddress');
